import * as React from "react";
import styled from "styled-components";
import theme from "./theme";
import Lightbox from "./modules/Lightbox";
import LoadingIcon from "./modules/LoadingIcon";
import Fallback from "./modules/Fallback";
import { isMobile, isTablet } from "react-device-detect";

import illuForeground from "./assets/images/illu_foreground.png";
import IlluBackground from "./IlluBackground";
import {
  IlluSection,
  ILLU_SECTION_IMAGES as ILLU_SECTIONS
} from "./IlluSections";

const ImageContainer = styled.div<{
  show: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: ${(p: any) => (p.show ? "1" : "0")};

  img {
    width: 100%;
  }
`;

const Wrapper = styled.div<{ currentLayer: IlluSection }>`
  position: relative;
  width: 100%;
  height: 100%;
  g#${IlluSection.storytelling},
    g#${IlluSection.solutions},
    g#${IlluSection.innovation},
    g#${IlluSection.refereeTechnologies},
    g#${IlluSection.performance} {
    transition: opacity 0.2s linear;
    cursor: pointer;
    &:hover {
      path {
        transition: fill 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        fill: ${theme.color.grey};
      }
    }
  }
`;

interface AppState {
  activeLayer: string;
  show: boolean;
  isLightBoxActive: boolean;
}

class App extends React.Component<{}, AppState> {
  constructor(props: {}) {
    super(props);
    this.addClickEvents = this.addClickEvents.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = {
      activeLayer: "",
      show: false,
      isLightBoxActive: false
    };
  }
  componentDidMount() {
    const img = new Image();
    img.onload = () => {
      this.addClickEvents();
      this.setState({
        show: true
      });
    };
    img.src = illuForeground;
  }
  componentDidUpdate() {
    if (!this.state.isLightBoxActive && this.state.activeLayer !== "") {
      setTimeout(() => {
        this.setState({
          isLightBoxActive: true
        });
      });
    }
  }
  handleClickEvent(layerId) {
    this.setState({
      activeLayer: layerId
    });
  }
  addClickEvents() {
    Object.values(IlluSection).forEach(id => {
      const layer = (document.getElementById(id) as any) as SVGGElement;
      layer.addEventListener("click", () => {
        this.handleClickEvent(id);
      });
    });
  }
  onClose() {
    this.setState({
      activeLayer: "",
      isLightBoxActive: false
    });
  }
  render() {
    const activeSection = ILLU_SECTIONS[this.state.activeLayer] || {};
    return (
      <>
        {isMobile || isTablet ? (
          <Fallback />
        ) : (
          <Wrapper currentLayer={this.state.activeLayer}>
            {/* NOTE: replaces ReactSVG loading prop for fade in transition */}
            {!this.state.show && <LoadingIcon />}
            <ImageContainer show={this.state.show}>
              <IlluBackground />
            </ImageContainer>
            <ImageContainer
              show={this.state.show}
              style={{ pointerEvents: "none" }}
            >
              <img src={illuForeground} />
            </ImageContainer>
            <Lightbox
              image={activeSection.image}
              title={activeSection.title}
              width={activeSection.width}
              height={activeSection.height}
              show={this.state.isLightBoxActive}
              onClose={this.onClose}
            />
            <div style={{ display: "none" }}>
              {Object.values(ILLU_SECTIONS).map(illu => {
                return <img key={illu.image} src={illu.image} />;
              })}
            </div>
          </Wrapper>
        )}
      </>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx